import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import { useNavigate } from "react-router-dom";
import { trackEmailVerified } from "@/lib/analyticsEvents";

const VerifyEmailPage = () => {
  const { theme } = useThemeConfig();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifica in corso...");
  const [showManualLink, setShowManualLink] = useState(false);

  useEffect(() => {
    // Flusso PKCE: il `code` di conferma viene scambiato automaticamente dal
    // client (detectSessionInUrl). Niente più token grezzi dall'URL (rischio
    // session fixation). Qui ci limitiamo a rilevare la sessione risultante.
    let settled = false;

    const onVerified = () => {
      if (settled) return;
      settled = true;
      window.history.replaceState({}, "", window.location.pathname);
      trackEmailVerified();

      const isMobile =
        navigator.userAgent.toLowerCase().includes("android") ||
        navigator.userAgent.toLowerCase().includes("iphone");

      if (isMobile) {
        window.location.href = "ceralia://login-success";
      } else {
        navigate("/");
      }
    };

    const fail = () => {
      if (settled) return;
      settled = true;
      setMessage("Token mancanti o link di verifica non valido.");
      setShowManualLink(true);
    };

    // Sessione già presente (auto-exchange concluso o utente già loggato).
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) onVerified();
    });
    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if ((event === "SIGNED_IN" || event === "INITIAL_SESSION") && session) {
        onVerified();
      }
    });
    // Rete di sicurezza: senza sessione (code mancante/scaduto o aperto su un
    // altro device, dove manca il code_verifier) mostra il fallback manuale.
    const timer = setTimeout(fail, 7000);

    return () => {
      clearTimeout(timer);
      sub.subscription.unsubscribe();
    };
  }, [navigate]);

  return (
    <div
      className="min-viewport-height flex items-center justify-center p-6"
      style={{ backgroundColor: theme.backgroundColor, color: theme.textColor }}
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4" style={{ color: theme.sectionTitleColor }}>
          Verifica email
        </h1>
        <p style={{ color: theme.sectionTextColor }}>{message}</p>
        {showManualLink && (
          <p className="mt-4" style={{ color: theme.sectionTextColor }}>
            <a href="/" className="underline" style={{ color: theme.primaryColor }}>
              Prosegui manualmente
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
